module.exports = __webpack_public_path__ + "static/media/Hbook-13.8a7bf1ec.jpg";